import {
  RESET_PROFILES,
  GET_PROFILES,
  SET_PROFILES,
  CREATE_PROFILES,
  CREATED_PROFILES,
  API_ERROR,
  GET_PROFILE,
  SET_PROFILE,
  EDIT_PROFILE,
  EDIT_PROFILE_SUCCESS,
  DELETE_PROFILE_SUCCESS,
  DELETE_PROFILE,
} from "./actionTypes";

const initialState = {
  errorProfile: false,
  loadingProfile: false,
  dataProfile: null,
  successProfile: false,
};

const Profile = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PROFILES:
      state = initialState;
      break;
    case GET_PROFILES:
      state = {
        errorProfile: false,
        loadingProfile: true,
        dataProfile: null,
      };
      break;
    case SET_PROFILES:
      state = {
        errorProfile: false,
        loadingProfile: false,
        dataProfile: action.payload,
      };
      break;
    case CREATE_PROFILES:
      state = {
        errorProfile: false,
        loadingProfile: true,
        dataProfile: action.payload,
        successProfile: false,
      };
      break;
    case CREATED_PROFILES:
      state = {
        errorProfile: false,
        loadingProfile: false,
        dataProfile: action.payload,
        successProfile: true,
      };
      break;
    case GET_PROFILE:
      state = {
        errorProfile: false,
        loadingProfile: true,
      };
      break;
    case SET_PROFILE:
      state = {
        errorProfile: false,
        loadingProfile: false,
        dataProfile: action.payload,
      };
      break;
    case EDIT_PROFILE:
      state = {
        errorProfile: false,
        loadingProfile: true,
        dataProfile: action.payload,
        successProfile: false,
      };
      break;
    case EDIT_PROFILE_SUCCESS:
      state = {
        errorProfile: false,
        loadingProfile: false,
        dataProfile: action.payload,
        successProfile: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorProfile: action.payload,
        loadingProfile: false,
        dataProfile: null,
        successProfile: false,
        loadingDeleteProfile: false,
        successDeleteProfile: false,
      };
      break;
    case DELETE_PROFILE:
      state = {
        ...state,
        errorProfile: false,
        loadingDeleteProfile: true,
        successDeleteProfile: false,
      };
      break;
    case DELETE_PROFILE_SUCCESS:
      state = {
        ...state,
        errorProfile: false,
        dataProfile: action.payload,
        loadingDeleteProfile: false,
        successDeleteProfile: true,
      };
      break;
    default:
      // state = { ...state, errorProfile: false, loadingProfile: false };
      break;
  }
  return state;
};

export default Profile;
